import { SET_VIEW } from 'store/constants/action-types';

const initialState = 'Inventory';

export function viewReducer(state = initialState, action) {
  switch (action.type) {
    case SET_VIEW:
      return action.payload;
    default:
      return state;
  }
}

export default viewReducer;
